export default {
    // session存储 当标签关闭或者 关闭浏览器 将不会用原有数据
    getSessionItem: function (key) {
        let value;
        try {
            value = sessionStorage.getItem(key);
        } catch (ex) {
            // 开发环境下提示error
            // if (__DEV__) {
            console.error('sessionStorage.getItem报错, ', ex.message)
            // }
        } finally {
            return value;
        }
    },
    setSessionItem: function (key, value) {
        try {
            // ios safari 无痕模式下，直接使用 localStorage.setItem 会报错
            sessionStorage.setItem(key, value);
        } catch (ex) {
            // 开发环境下提示 error
            // if (__DEV__) {
            console.error('sessionStorage.setItem报错, ', ex.message);
            // }
        }
    },

    removeSeesionItem:function (key) {
        try {
            // ios safari 无痕模式下，直接使用 localStorage.setItem 会报错
            sessionStorage.removeItem(key);
        } catch (ex) {
            // 开发环境下提示 error
            // if (__DEV__) {
            console.error('sessionStorage.setItem报错, ', ex.message);
            // }
        }
    }


}


// WEBPACK FOOTER //
// ./src/util/sessionStore.js